export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/sales_copy.1ef2bbd.svg";